module.exports = __webpack_public_path__ + "static/media/check-solid.82876d42.svg";